// hooks/useApi.js
import { useMemo } from 'react';
import { useData } from '@/context/hooks/DataProvider';
import { createApiHook } from '@/lib/http/api';

export const useApi = () => {
    const { openLogin, logout } = useData();
    return useMemo(() => {
        return createApiHook(async () => {
            return new Promise(async (resolve, reject) => {
                await logout();
                openLogin(
                    () => resolve(), // 登录成功回调
                    (error) => reject(error) // 登录取消回调
                );
            })
        });
    }, [openLogin, logout]);
};